import { shopScene } from '../shopkit.js';

/** 货栈：大宗货物的集散地，接委托、交包袱都在这儿。 */
export const depotDoc = shopScene({
  id: 'depot',
  name: '货栈',
  shop: 'depot',
  owner: '账房',
  desc: '货架顶到房梁，空气中飘着麻布和灰尘。',
  w: 26, h: 20,
  counters: [{ gx: 10, gy: 3, len: 5, kind: 'depot' }],
  props: [
    { type: 'warehouse_shelves', gx: 3, gy: 7 },
    { type: 'warehouse_shelves', gx: 4, gy: 7 },
    { type: 'warehouse_shelves', gx: 20, gy: 7 },
    { type: 'agent_desk', gx: 15, gy: 12 },
    { type: 'cargo_scale', gx: 21, gy: 14 },
    { type: 'straw_mat', gx: 5, gy: 15 },
  ],
  portals: [
    { to: 'riverfront', gx: 13, gy: 19, spawn: [12, 9], label: '回河埠' },
  ],
});

export default depotDoc;
